module.exports = __webpack_public_path__ + "img/02.b578da62.jpg";